export default "__VITE_ASSET__yPHmCYQo__"